<kendo-gridlayout class="stats-grid" [gap]="12">
  <ng-content />
</kendo-gridlayout>
